// extracted by mini-css-extract-plugin
export default {"root":"video_root__bpVz6","video":"video_video__Qwovj","fill":"video_fill__mIZBv","playIcon":"video_playIcon__9umrM","adaptive":"video_adaptive__c60oj"};